// C端商城路由前缀
export const MALL_ROUTE_PREFIXES = ['/mall']
